/**************************************************
 * Nombre:       Dialogo_Historia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import Formulario_Historia from "../Formularios/Formulario_Historia";
import {subirVideoHostingFile} from "../../Servicios/AlmacenamientoHosting/subirVideoHostingFile";
import {subirMultiplesImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirMultiplesImagenHostingFile";

const Dialogo_Historia = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        if (!entidad.video) {
            terminar({aviso: 'El video es necesario para saber tu historia', variante: 'error'})
            return
        }

        iniciarCarga('Subiendo historia, porfavor espere unos segundos')
        entidad.fecha = new Date().getTime()
        let resultado = await subirVideoHostingFile(entidad.video)
        entidad.video = resultado.data
        entidad.estado = 'Nuevo'

        let doxImgs = await subirMultiplesImagenHostingFile(entidad.imgs)
        entidad.imgs = doxImgs.data


        entidad.idUsuario = cData.usuario.id
        entidad.nombre = cData.usuario.nombre
        entidad.correo = cData.usuario.correo
        entidad.celular = cData.usuario.celular
        entidad.pais = cData.usuario.pais


        let dox = await guardarDoc('historias', entidad)
        if (dox.res) {
            terminar({aviso: 'Historia subida con exito'})
        } else {
            terminar({aviso: 'Algo salio mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Historia props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Subir mi historia</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Historia